import React from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import StateComponents from '../../../components/state-component/StateComponents';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import ManageState from './manageState';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';

export default function PeriodExamination() {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("PERIOD_EXAMINATION")}
                // hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("ตั้งค่า"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("หมวดหมู่แกลเลอรี"),
                //                 pathName: routeName.cms_website.GalleryTypeManagement
                //             },
                //         ]}
                //     />
                // }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("PERIOD_EXAMINATION_SEARCH_NAME"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("PERIOD_EXAMINATION_DATE_RANGE")
                                    }
                                },
                                {
                                    type: "COMPONENT",
                                    seq: 3,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("PERIOD_EXAMINATION_ADD"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        navigate(routeName.admission.period_examination_add)
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

        </div>
    )
}
